import { Box, Button, Divider, Typography, useTheme } from '@mui/material';

type QueueDisplayHeaderPropsT = {
  onCloseBtnClick?: () => void;
};

function QueueDisplayHeader({
  onCloseBtnClick: handleCloseBtnClick,
}: QueueDisplayHeaderPropsT) {
  const { palette } = useTheme();
  return (
    <>
      <Box
        sx={{
          backgroundColor: palette.background.paper,
          height: '44px',
          flex: '0 0 44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          color="white"
          align="center"
          sx={{ userSelect: 'none' }}
        >
          호출 상태
        </Typography>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
          }}
        >
          {handleCloseBtnClick && (
            <Button
              variant="text"
              onClick={handleCloseBtnClick}
              sx={{ px: '12px', minWidth: 0 }}
            >
              닫기
            </Button>
          )}
        </Box>
      </Box>
      <Divider />
    </>
  );
}

export default QueueDisplayHeader;
